var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"folders-list flex-wrap pt-5",class:[!!_vm.scrollBarWidth ? 'px-4' : 'px-2'],style:({
    'grid-template-columns': ("repeat(" + (_vm.$store.getters.columnCount) + ", " + (_vm.$store.getters.columnWidth) + "px)")
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }